import { render, staticRenderFns } from "./AccountCoinHistory.vue?vue&type=template&id=da5d2546&"
import script from "./AccountCoinHistory.vue?vue&type=script&lang=ts&"
export * from "./AccountCoinHistory.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCoinHistory.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports